module.exports = __webpack_public_path__ + "fonts/STKBureauSans-Medium.c6ba0460fb27ff06e80117406a6181bf.woff";